module.exports = [{"title":"АРК-ЭнергоСбыт – эксперт в области энерготрейдинга","text":"АРК-ЭнергоСбыт – эксперт в области энерготрейдинга","liItems":["Принципы<br/>работы","Договоры","География<br/>потребителей","Опыт работы"],"imageUrl":"@/components/slider/img-01.jpg"},{"title":"1 000 000 000 Киловатт-часов в 27 регионах России","text":"1 000 000 000 Киловатт-часов в 27 регионах России","imageUrl":"@/components/slider/img-02.jpg"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/items.json
// module id = 150
// module chunks = 0